import { render, staticRenderFns } from "./notification-card.vue?vue&type=template&id=29e5f756&"
import script from "./notification-card.vue?vue&type=script&lang=js&"
export * from "./notification-card.vue?vue&type=script&lang=js&"
import style0 from "./notification-card.vue?vue&type=style&index=0&id=29e5f756&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports